import { ConfirmationModal } from "@packages/ui/components";
import { signOut } from "next-auth/react";
import Image from "next/image";
import { EXPIRED } from "@public/index";

const SessionExpireAlert = ({
  open,
  handleClose,
  subheader,
}: {
  open: boolean;
  handleClose: any;
  subheader: string;
}) => {
  const handleCloseModal = () => {
    localStorage.setItem("sessionExpiryAlert", "true");
    handleClose();
  };

  const handleSignin = () => {
    localStorage.removeItem("sessionExpiryAlert");
    localStorage.removeItem("selectedSubItem");
    localStorage.removeItem("terminal_file_statuses");
    localStorage.removeItem("userReactions");
    localStorage.removeItem("guidedTour");
    localStorage.removeItem("shareholderGuide");
    sessionStorage.clear();
    handleClose();
    signOut();
  };

  return (
    <>
      <ConfirmationModal
        open={open}
        iconSvg={<Image src={EXPIRED} alt="expiredIcon" />}
        title={"Session Going to Expire"}
        desc={subheader}
        containedButtonTitle="Login Again"
        outlinedButtonTitle="Cancel"
        outlinedOnClick={handleCloseModal}
        containedOnClick={handleSignin}
      />
    </>
  );
};

export default SessionExpireAlert;
